import PropTypes from 'prop-types';
import React, { Component } from 'react';
import PrintOutScreenshot from '../PrintOutScreenshot/PrintOutScreenshot';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class PrintOutOptions extends Component {

  static propTypes = {
    dealer: PropTypes.object.isRequired,
    edit: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    intl: intlShape.isRequired
  };

  handleChange = (e) => {
    if (this.props.onChange && this.props.edit) {
      this.props.onChange({key: 'keyParametersRanges', value: e.target.value === 'true'});
    }
  };

  handleClick = (e) => {
    if (this.props.onClick && this.props.edit) {
      e.stopPropagation();
      this.props.onClick({key: 'keyParametersRanges', value: e.target.value === 'true'});
    }
  };

  renderClassName(keyParametersRanges) {
    if (keyParametersRanges && !this.props.edit) {
      return 'rad-inactive';
    } else if(keyParametersRanges) {
      return 'rad-selected';
    } else {
      return 'rad-not-selected';
    }
  }

  render() {
    let keyParametersRanges = this.props.dealer.keyParametersRanges;
    let {formatMessage} = this.props.intl;

    return <div>
      <h2 className='with-keyline'>
        <FormattedMessage id='preferences.analysis.printout'/>
      </h2>
      <div className='col-xs-12'>
        <div className='view-printout-wrapper'>
          <div className='printout-options'>
            <label className="rad">
              <input type='radio'
                value={true}
                checked={!!keyParametersRanges}
                onChange={this.handleChange} />
              <i className={this.renderClassName(keyParametersRanges)} onClick={this.handleClick} /> {formatMessage({id: 'preferences.analysis.printout.new'})}
            </label>
          </div>
          <PrintOutScreenshot 
              title={formatMessage({id: 'preferences.analysis.printout.new'})}
              name={formatMessage({id: 'preferences.analysis.printout.new'})}
              value={false}/>
        </div>
        
        <div className='view-printout-wrapper'>
          <div className='printout-options'>
            <label className="rad">
              <input type='radio'
                value={false}
                checked={!keyParametersRanges}
                onChange={this.handleChange} />
              <i className={this.renderClassName(!keyParametersRanges)} onClick={this.handleClick} />  {formatMessage({id: 'preferences.analysis.printout.original'})}
            </label>
          </div>
          <PrintOutScreenshot 
              title={formatMessage({id: 'preferences.analysis.printout.original'})}
              name={formatMessage({id: 'preferences.analysis.printout.original'})}
              value={true}/>
        </div>
      </div>
    </div>;
  }
}

export default injectIntl(PrintOutOptions);